import K2Api from "lib/ajax/K2Api";

export default class Session {

	async fetch() {
		try {
			const k2Api = new K2Api();
			const bsso = await k2Api.get('/session');
			const user = bsso.data;
			localStorage.setItem('session', JSON.stringify(user));
		} catch (err) {
			console.error(err);
		}
	}

	async areWeAuthenticated() {
		try {
			const k2Api = new K2Api();
			const response = await k2Api.get('/session');
			return { status: true, response: response };
		} catch (err) {
			return { status: false, response: err.response };
		}
	}

	get() {
		if (localStorage.getItem('session') == null) {
			this.fetch();
		}
		return (JSON.parse(localStorage.getItem('session')));
	}

	getUserName() {
		const userName = this.get()?.user?.name || "";
		return (userName);
	}

	getUserEmail() {
		const userEmail = this.get()?.user?.email || "";
		return (userEmail);
	}

	hasPermission(permission) {
		const bluePermission = `blue.${permission}`;
		const data = this.get();
		if (!data || !Array.isArray(data.permissions)) {
			return false;
		}
		return (data.permissions.indexOf(bluePermission) !== -1);
	}

	gainsights() {
		var data = this.get();
		window.aptrinsic('identify', { id: data.user.name })
	}

	delete() {
		localStorage.removeItem('session');
	}
}
